/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApprenantFichierGridDto } from './ApprenantFichierGridDto';
import {
    ApprenantFichierGridDtoFromJSON,
    ApprenantFichierGridDtoFromJSONTyped,
    ApprenantFichierGridDtoToJSON,
} from './ApprenantFichierGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ApprenantFichierGridDtoPaginatedResults
 */
export interface ApprenantFichierGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ApprenantFichierGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ApprenantFichierGridDto>}
     * @memberof ApprenantFichierGridDtoPaginatedResults
     */
    results?: Array<ApprenantFichierGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ApprenantFichierGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ApprenantFichierGridDtoPaginatedResults interface.
 */
export function instanceOfApprenantFichierGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantFichierGridDtoPaginatedResultsFromJSON(json: any): ApprenantFichierGridDtoPaginatedResults {
    return ApprenantFichierGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ApprenantFichierGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantFichierGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ApprenantFichierGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ApprenantFichierGridDtoPaginatedResultsToJSON(value?: ApprenantFichierGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ApprenantFichierGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

